module.exports = __webpack_public_path__ + "f680dfcd57247ee54315dd05e294126a.png";